import { configureStore } from "@reduxjs/toolkit";
import announcementsSlice from "./slices/announcementsSlice";
import authSlice from "./slices/authSlice";
import discountsSlice from "./slices/discountsSlice";
import { USE_MOCK_API, mockPreloadedState } from "../mocks";

const store = configureStore({
  reducer: {
    auth: authSlice,
    discounts: discountsSlice,
    announcements: announcementsSlice,
  },
  // In mock mode the app boots already signed in, so the store starts with the
  // mock session instead of the empty initial state.
  preloadedState: USE_MOCK_API ? mockPreloadedState : undefined,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
